"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWindowSize;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

var _react = require("react");

var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';

function getSize() {
  return {
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined
  };
}

function useWindowSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 0 : _ref$debounce;

  var timeout = (0, _react.useRef)();

  var _useState = (0, _react.useState)(getSize),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var handleResize = (0, _react.useCallback)(function () {
    if (debounce) {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      timeout.current = setTimeout(function () {
        setWindowSize(getSize());
      }, debounce);
    } else {
      setWindowSize(getSize());
    }
  }, [timeout.current]);
  (0, _react.useEffect)(function () {
    if (!isClient) {
      return false;
    }

    window.addEventListener('resize', handleResize);
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      window.removeEventListener('resize', handleResize);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}